module.exports = __webpack_public_path__ + "static/media/Auto-Glass.8d711584.jpg";